var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-main-row"},[_vm._t("column",[_c('div',{staticClass:"cell-main-row-left van-ellipsis"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"cell-main-row-right",class:_vm.textClass},[_vm._v(_vm._s(_vm.text))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }